export enum CarouselActionType {
  CarouselClick = 'Carousel Click',
  CarouselButton = 'Carousel Button',
  PDPCarouselButton = 'PDP Carousel Button',
  CustomHubPageCarouselButton = 'CustomHubPage Carousel Button',
  PDPCarouselSwipe = 'PDP Carousel Swipe',
  ContentCarouselButton = 'Content Carousel Button',
  ContentCarouselSwipe = 'Content Carousel Swipe',
  HorizontalScroll = 'horizontal_scroll',
}
